/**
 * Obtiene la marca de tiempo en milisegundos en formato UTC.
 * @returns {number} La marca de tiempo en milisegundos en formato UTC.
 */
export const getNowMsTimeStampUTC = () => {
  const now = new Date();
  const utcTimestamp = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds(),
    now.getUTCMilliseconds()
  );
  return utcTimestamp;
};
